<div class="mkt-announcement-template-dialogBox">
  <div class="template-header mb-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">

        <div class="template-description width-100p p-relative">
          Send Preview Email
        </div>
        <i id="template-close-dialog" class="far fa-times pointer dialog-close" (click)="closeDialog()"></i>
      </div>
    </div>
  </div>
  <div class="row preview-icon-row">

    <div class="input-basic-info-wrapper ui-g-12 p-0 pb-2 preview-icon-row-wrapper">
      <div class="input-default-style mb-0">

        <div class="ui-g-12 p-0 input-control-container mt-1">
          <div class="ui-g-12 p-0 flex-start-center pr-3">
            <div class="icon flex-center-start m-left-10">
              <i class="far fa-envelope height-icon font-14"></i>
            </div>

            <div class="width-100p template-contact-info-wrapper m-left-10">
              <app-input id="template-test-email" type="text" placeholder="Email" style="flex: 0 0 275px;" theme="light"
                maxlength="50" [fontSize]="14" [errorMessage]="errors.email" [isInvalid]="errors.email"
                [floatingLabel]="true" [value]="template.email" (appFocus)="errors.email = ''"
                (appChange)="handleChange('email', $event)">
              </app-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-g-12 flex-between-center dialog-footer part-footer pt-3 pb-2">
    <div class="part-add-dialog-footer width-100p content-end">
      <div class="align-self-center col-4 m-top-neg-15 input-default-style mb-0">
      </div>
      <button id="template-cancel-btn" class="btn btn-white btn-border pointer btn-submit mr-2" (click)="closeDialog()">
        Cancel
      </button>
      <button id="template-save-btn" class="btn btn-primary btn-submit" (click)="sendPreviewEmail()">
        <span [ngClass]="{'pr-2': isSending}">Send</span>
        <i *ngIf="isSending" class="far fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>